import styled from 'styled-components';

export const StyledEditMapPageInfo = styled.div`
  margin-bottom: 1rem;
`;
